import { useQuery } from "@tanstack/react-query";

import { profileApi } from "@/features/profile/services/profile.api";
import { useAppSelector } from "@/store/hooks";

export function useMyProfile() {
  const isAuthenticated = useAppSelector((state) => state.auth.status === "authenticated");
  return useQuery({
    queryKey: ["profile", "me"],
    queryFn: profileApi.getMyProfile,
    enabled: isAuthenticated,
  });
}
